var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSystemMessageInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.8V16.2C20 16.6774 19.8055 17.1352 19.4593 17.4728C19.1131 17.8104 18.6435 18 18.1538 18H5.84615C5.35652 18 4.88695 17.8104 4.54073 17.4728C4.1945 17.1352 4 16.6774 4 16.2V7.8M20 7.8C20 7.32261 19.8055 6.86477 19.4593 6.52721C19.1131 6.18964 18.6435 6 18.1538 6H5.84615C5.35652 6 4.88695 6.18964 4.54073 6.52721C4.1945 6.86477 4 7.32261 4 7.8M20 7.8V7.9944C20 8.30172 19.9194 8.60392 19.7657 8.87224C19.612 9.14055 19.3904 9.36603 19.1221 9.5272L12.9682 13.2192C12.6771 13.394 12.3419 13.4866 12 13.4866C11.6581 13.4866 11.3229 13.394 11.0318 13.2192L4.87795 9.528C4.60958 9.36683 4.388 9.14135 4.23431 8.87304C4.08063 8.60472 3.99997 8.30252 4 7.9952V7.8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSystemMessageInactive);
export default __webpack_public_path__ + "static/media/MobileSystemMessageInactive.58e69aa27f4b2b12b45da3732fafc15a.svg";
export { ForwardRef as ReactComponent };